import {
  PSMS_CALLS_CHATS_DETAILS_REQUEST,
  PSMS_CALLS_CHATS_TREND_REQUEST,
} from '@src/middleware/actions/actionTypes';
import {
  fetchCallsChatsDetailsFailure,
  fetchCallsChatsDetailsLoading,
  fetchCallsChatsDetailsSuccess,
  fetchCallsChatsTrendFailure,
  fetchCallsChatsTrendLoading,
  fetchCallsChatsTrendSuccess,
} from '@src/middleware/actions/psms/callsChatsActions';
import {
  getPSMSCallsChatsDetails,
  getPSMSCallsChatsTrend,
} from '@src/middleware/services/psms/callsChats.service';
import { call, put, takeLatest } from 'redux-saga/effects';

/**
 * Worker Saga: Handle fetching calls/chats details
 */
function* handleFetchCallsChatsDetails(action: any) {
  try {
    yield put(fetchCallsChatsDetailsLoading(true));

    let response = yield call(getPSMSCallsChatsDetails, action.payload);

    // Retry logic for 504 timeouts
    if (response?.status === 504) {
      response = yield call(getPSMSCallsChatsDetails, action.payload);
    }

    // Check for successful response
    if (response?.StatusCode === 200 && response?.Data) {
      yield put(fetchCallsChatsDetailsSuccess(response.Data));
    } else {
      yield put(fetchCallsChatsDetailsSuccess(null));
      yield put(fetchCallsChatsDetailsFailure(response?.Message || 'No data available.'));
    }
  } catch (error: any) {
    if (error?.response?.status === 504) {
      yield put(fetchCallsChatsDetailsSuccess(null));
      yield put(fetchCallsChatsDetailsFailure('Server timeout. Please try again later.'));
    } else {
      yield put(
        fetchCallsChatsDetailsFailure(error?.message || 'Failed to fetch Calls/Chats Details data')
      );
    }
  } finally {
    yield put(fetchCallsChatsDetailsLoading(false));
  }
}

/**
 * Worker Saga: Handle fetching calls/chats trend data
 */
function* handleFetchCallsChatsTrend(action: any) {
  try {
    yield put(fetchCallsChatsTrendLoading(true));

    let response = yield call(getPSMSCallsChatsTrend, action.payload);

    // Retry logic for 504 timeouts
    if (response?.status === 504) {
      response = yield call(getPSMSCallsChatsTrend, action.payload);
    }

    // Check for successful response
    if (response?.StatusCode === 200 && response?.Data) {
      yield put(fetchCallsChatsTrendSuccess(response.Data));
    } else {
      yield put(fetchCallsChatsTrendSuccess(null));
      yield put(fetchCallsChatsTrendFailure(response?.Message || 'No trend data available.'));
    }
  } catch (error: any) {
    if (error?.response?.status === 504) {
      yield put(fetchCallsChatsTrendSuccess(null));
      yield put(fetchCallsChatsTrendFailure('Server timeout. Please try again later.'));
    } else {
      yield put(
        fetchCallsChatsTrendFailure(error?.message || 'Failed to fetch Calls/Chats Trend data')
      );
    }
  } finally {
    yield put(fetchCallsChatsTrendLoading(false));
  }
}

/**
 * Watcher Saga: Watch for PSMS_CALLS_CHATS_DETAILS_REQUEST and PSMS_CALLS_CHATS_TREND_REQUEST
 */
export function* callsChatsSaga() {
  yield takeLatest(PSMS_CALLS_CHATS_DETAILS_REQUEST, handleFetchCallsChatsDetails);
  yield takeLatest(PSMS_CALLS_CHATS_TREND_REQUEST, handleFetchCallsChatsTrend);
}
